module.exports = __webpack_public_path__ + "assets/img/3b96-ta.svg";